export default __webpack_public_path__ + "static/media/barcelona.d980d22c.png";